<div class="header">
  <div class="sidenav-btn">
    <button type="button" mat-icon-button (click)="drawer.toggle()" *ngIf="!drawer.opened">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <div class="brand">
    <div class="brand-logos">
      <img class="brand-logo" [alt]="title" src="../../../../assets/images/logo-header.png"/>
      <img class="brand-logo" [alt]="title" src="../../../../assets/images/kpsk-vyshneve.jpg"/>
    </div>
    <div class="title-container">
      <span class="title">
        <span class="title-prefix">{{title.split(' ')[0] + ' ' + title.split(' ')[1]}}</span>
        <span class="main-name">{{title.split(' ')[2]}}</span>
      </span>
      <span class="subtitle">{{subtitle}}</span>
    </div>
  </div>

  <div class="header-actions">
    <button mat-stroked-button [routerLink]="'/auth'" *ngIf="!user" class="login-btn">
      <mat-icon class="auth-icon">login</mat-icon><span class="login-text">Увійти</span>
    </button>
    <div class="user-menu" *ngIf="user" [matMenuTriggerFor]="menu">
      <button mat-button class="user-menu-trigger">
        <mat-icon class="user-icon">person</mat-icon>
        <span class="user-name">{{user.firstName}} {{user.secondName}}</span>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="toEditProfile()"><mat-icon class="menu-icon">settings</mat-icon>Налаштування</button>
        <button mat-menu-item (click)="logout()"><mat-icon class="menu-icon">exit_to_app</mat-icon>Вийти</button>
      </mat-menu>
    </div>
  </div>
</div>
